/*
 * @Author: cn1994
 * @Date: 2023-08-02 16:19:13
 * @LastEditors: cn1994
 * @LastEditTime: 2024-01-26 15:53:08
 * @Description: file content
 *
 */

const routes = [
  // 校区管理
  {
    path: '/begin/campus',
    name: 'begin/campus',
    meta: {
      title: '校区管理'
    },
    component: () => import('@/pages/begin/campus.vue'),
  },
  // 科目管理
  {
    path: '/begin/subject',
    name: 'begin/subject',
    meta: {
      title: '科目管理'
    },
    component: () => import('@/pages/begin/subject.vue'),
  },
  // 切换服务
  {
    path: '/begin/server',
    name: 'begin/server',
    meta: {
      title: '切换服务'
    },
    component: () => import('@/pages/begin/server.vue'),
  },
  // 开通校区
  {
    path: '/begin/createCampus',
    name: 'begin/createCampus',
    meta: {
      title: '创建校区'
    },
    component: () => import('@/pages/begin/createCampus.vue'),
  },
  // 开通科目
  {
    path: '/begin/createSubject',
    name: 'begin/createSubject',
    meta: {
      title: '创建科目'
    },
    component: () => import('@/pages/begin/createSubject.vue'),
  },
  // 编辑校区
  {
    path: '/begin/editCampus',
    name: 'begin/editCampus',
    meta: {
      title: '编辑校区'
    },
    component: () => import('@/pages/begin/editCampus.vue'),
  },
  // 数据中心v2版本
  {
    path: '/begin/dataCenterV2',
    name: 'begin/dataCenterV2',
    meta: {
      title: '数据中心-学校（校区）维度v2'
    },
    component: () => import('@/pages/begin/dataCenterV2.vue'),
  },
]

export default routes
